var map = {
	"./1.refri1.jpeg": 4658,
	"./10.civil1.jpeg": 4058,
	"./2.civil4.jpeg": 6597,
	"./3.mec2.jpeg": 7696,
	"./4.mec1.jpeg": 1495,
	"./5.elet1.jpeg": 5147,
	"./6.civil5.jpeg": 5492,
	"./7.mec3.jpeg": 7304,
	"./8.coz1.jpeg": 9822,
	"./9.civil2.jpeg": 6550,
	"./Untitled Folder/1.jpeg": 3347,
	"./Untitled Folder/civil3.jpeg": 5373,
	"./Untitled Folder/crop.jpg": 699,
	"./Untitled Folder/elet2.jpeg": 4145
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3746;